import { useEffect, useState } from "react";
import Api from "../../../../services/Api";
import Functions from "../../../../services/Functions";
import BarGraph from "../../../general/BarGraph";
import PieGraph from "../../../general/PieGraph";
import SmallPieGraph from "../../../general/SmallPieGraph";
import styles from "./AmbientalL3.module.css";
import { AmbientalStore } from "./AmbientalStore";

function AmbientalL3({ distrito }) {
  const [agrotoxico, setAgrotoxico] = useState(null);
  const [problemaSaudeAgrotoxico, setProblemaSaudeAgrotoxico] = useState(null);
  const [tipoMata, setTipoMata] = useState(null);
  const [agrotoxicoOldValue, setAgrotoxicoOldValue] = useState(null);
  const [problemaSaudeAgrotoxicoOldValue, setProblemaSaudeAgrotoxicoOldValue] =
    useState(null);

  const nascentesValue = AmbientalStore((state) => state.nascentesValue);

  const aguaCorrenteValue = AmbientalStore((state) => state.aguaCorrenteValue);

  const mataValue = AmbientalStore((state) => state.mataValue);

  const agrotoxicoValue = AmbientalStore((state) => state.agrotoxicoValue);

  const problemaSaudeAgrotoxicoValue = AmbientalStore(
    (state) => state.problemaSaudeAgrotoxicoValue
  );

  const setAgrotoxicoValue = AmbientalStore(
    (state) => state.setAgrotoxicoValue
  );

  const setProblemaSaudeAgrotoxicoValue = AmbientalStore(
    (state) => state.setProblemaSaudeAgrotoxicoValue
  );

  const setAgrotoxicoImage = AmbientalStore(
    (state) => state.setAgrotoxicoImage
  );

  const setProblemaSaudeAgrotoxicoImage = AmbientalStore(
    (state) => state.setProblemaSaudeAgrotoxicoImage
  );

  const setTipoMataImage = AmbientalStore((state) => state.setTipoMataImage);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const [agrotoxico, problemaSaudeAgrotoxico, tipoMata] =
          await Promise.all([
            Api.getAgrotoxico(
              distrito,
              nascentesValue,
              aguaCorrenteValue,
              mataValue,
              null,
              problemaSaudeAgrotoxicoValue
            ),
            Api.getProblemasSaudeAgrotoxico(
              distrito,
              nascentesValue,
              aguaCorrenteValue,
              mataValue,
              agrotoxicoValue,
              null
            ),
            Api.getTipoMata(
              distrito,
              nascentesValue,
              aguaCorrenteValue,
              mataValue,
              agrotoxicoValue,
              problemaSaudeAgrotoxicoValue
            ),
          ]);
        setAgrotoxico(Functions.buildSmallPieGraphParams(agrotoxico));
        setProblemaSaudeAgrotoxico(
          Functions.buildPieGraphParams2(problemaSaudeAgrotoxico)
        );
        setTipoMata(Functions.buildBarGraph(tipoMata));
      } catch (error) {
        console.error("Erro ao buscar dados:", error);
      }
    };
    fetchData();
  }, [
    distrito,
    nascentesValue,
    aguaCorrenteValue,
    mataValue,
    agrotoxicoValue,
    problemaSaudeAgrotoxicoValue,
  ]);

  const onAgrotoxicoClick = (value) => {
    setAgrotoxicoValue(value);
  };

  const onProblemaSaudeAgrotoxicoClick = (value) => {
    setProblemaSaudeAgrotoxicoValue(value);
  };

  return (
    <div className={styles.ambientalL3}>
      <div className={styles.pieGraph}>
        <div className={styles.graph}>
          {agrotoxico && (
            <SmallPieGraph
              data={agrotoxico}
              text="USO DE AGROTÓXICO"
              onLegendClick={onAgrotoxicoClick}
              currentValue={agrotoxicoValue}
              oldValue={agrotoxicoOldValue}
              onOldValue={setAgrotoxicoOldValue}
              onImageReady={setAgrotoxicoImage}
            />
          )}
        </div>
      </div>

      <div className={styles.pieGraph}>
        <div className={styles.graph}>
          {problemaSaudeAgrotoxico && (
            <PieGraph
              data={problemaSaudeAgrotoxico}
              text="PROBLEMA DE SAÚDE (AGROTÓXICO)"
              onLegendClick={onProblemaSaudeAgrotoxicoClick}
              currentValue={problemaSaudeAgrotoxicoValue}
              oldValue={problemaSaudeAgrotoxicoOldValue}
              onOldValue={setProblemaSaudeAgrotoxicoOldValue}
              onImageReady={setProblemaSaudeAgrotoxicoImage}
            />
          )}
        </div>
      </div>

      <div className={styles.pieGraph}>
        <div className={styles.graph}>
          {tipoMata && (
            <BarGraph
              data={tipoMata}
              text="TIPO DE MATA"
              onImageReady={setTipoMataImage}
            />
          )}
        </div>
      </div>
    </div>
  );
}

export default AmbientalL3;
